import getFallbackLanguage from 'common/utils/getFallbackLanguage';

export const SHARE2_SCRIPT = 'https://yastatic.net/share2/share.js';

const {lang} = window.YC;

// Doc: https://yandex.ru/dev/share/doc/ru/api#theme
const availableShareLangs = [
    'az',
    'be',
    'en',
    'hy',
    'ka',
    'kk',
    'ro',
    'ru',
    'tr',
    'tt',
    'uk',
    'uz',
];

export const shareLang = availableShareLangs.includes(lang) ? lang : getFallbackLanguage(lang);
